import * as React from 'react';

function ChevronDownSmall(props) {
    return React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 14", className: "c-pieIcon c-pieIcon--ChevronDownSmall", width: "1em", height: "1em" }, props),
        React.createElement("path", { d: "M1.82 4.04375L7 9.39875L12.1975 4L13.16 4.875L7.79625 10.44C7.5784 10.6553 7.28444 10.7761 6.97812 10.7761C6.67181 10.7761 6.37785 10.6553 6.16 10.44L0.875 4.945L1.82 4.04375Z" }));
}

export { ChevronDownSmall as default };
